import React from 'react';

/**
 * 解析句子文本中的 <i>...</i> 标签为结构化片段数组
 * @param {string} text - 可能包含 <i>...</i> 标签的字符串
 * @returns {Array<{text: string, italic: boolean}>} 解析后的片段数组
 */
export const parseSentenceText = (text) => {
  if (!text || typeof text !== 'string') return [];

  const segments = [];
  const regex = /<i>(.*?)<\/i>/g;
  let lastIndex = 0;
  let match;

  while ((match = regex.exec(text)) !== null) {
    // 添加标签前的普通文本
    if (match.index > lastIndex) {
      segments.push({ text: text.slice(lastIndex, match.index), italic: false });
    }
    // 添加斜体文本
    if (match[1].length > 0) {
      segments.push({ text: match[1], italic: true });
    }
    lastIndex = regex.lastIndex;
  }

  // 添加最后一段普通文本
  if (lastIndex < text.length) {
    segments.push({ text: text.slice(lastIndex), italic: false });
  }

  return segments;
};

/**
 * 将解析后的片段数组序列化回包含 <i>...</i> 标签的字符串
 * @param {Array<{text: string, italic: boolean}>} parts - 解析后的片段数组
 * @returns {string} 包含 <i>...</i> 标签的字符串
 */
export const serializeSentenceText = (parts) => {
  if (!parts || !Array.isArray(parts)) return '';
  return parts.map(part => part.italic ? `<i>${part.text}</i>` : part.text).join('');
};

/**
 * 将句子文本格式化为 React 元素，<i>...</i> 标签内的文本以斜体渲染
 * @param {string} text - 可能包含 <i>...</i> 标签的字符串
 * @returns {React.ReactNode} React 元素或空字符串
 */
export const formatSentenceText = (text) => {
  if (!text || typeof text !== 'string') return '';

  const segments = parseSentenceText(text);
  if (segments.length === 0) return '';

  // 如果只有一个非斜体片段，直接返回文本
  if (segments.length === 1 && !segments[0].italic) {
    return segments[0].text;
  }

  return segments.map((segment, index) =>
    segment.italic
      ? React.createElement('em', { key: index }, segment.text)
      : segment.text
  );
};
